import * as R from 'ramda';
import { OrderBy, OrderType } from '../Hooks/useList.types';
import { ParamValue } from './useFilter.types';

export const getValidOrderType = (orderTypeString: string): OrderType =>
  orderTypeString?.toUpperCase() === 'ASC' ? 'ASC' : 'DESC';

export const arg2Order = (value?: ParamValue): OrderBy => {
  if (!value || typeof value !== 'string') {
    return {};
  }
  const order: OrderBy = {};
  const orderFields = value.split('-');
  for (let index = 0; index < orderFields.length; index += 1) {
    const orderField = orderFields[index];
    const orderParts = orderField.split('__');
    order[orderParts[0]] = getValidOrderType(orderParts[1]);
  }

  return order;
};

export const extractOrderFromValues = (values?: Record<string, any>): OrderBy | undefined => {
  if (!values || !values.order) {
    return undefined;
  }

  return typeof values.order === 'string' ? arg2Order(values.order) : undefined;
};

export const toValue = (value: ParamValue) => {
  if (value === 'null') {
    return null;
  }
  return value;
};

const isValidKeyOrValue = (value: any) => {
  if (value !== false && R.isNil(value)) {
    return false;
  }

  if (typeof value === 'string' && value.trim().length === 0) {
    return false;
  }

  return true;
};

export const appendIfValidFilterValues = (
  searchParams: URLSearchParams,
  key: string,
  value: any,
) => {
  if (isValidKeyOrValue(key) && isValidKeyOrValue(value)) {
    searchParams.append(key, value);
  }
};

export const orderToArg = (order: OrderBy) => {
  if (typeof order === 'string') {
    return order;
  }
  const orderFields: string[] = [];
  const orderKeys = Object.keys(order);

  for (let index = 0; index < orderKeys.length; index += 1) {
    const key = orderKeys[index];
    orderFields.push(`${key}__${order[key]}`);
  }

  return orderFields.join('-');
};
